module.exports = __webpack_public_path__ + "static/media/h8.987dcf36.jpeg";